import { API_JWT_REFRESH_TOKEN_NAME, CALL_API } from '../middleware/api'
import StorageProviderFactory from '../managers/storage_provider_factory'
import { STORAGE_TYPE_LOCAL } from '../config'

export const TOKEN_REFRESH_REQUEST = 'TOKEN_REFRESH_REQUEST'
export const TOKEN_REFRESH_SUCCESS = 'TOKEN_REFRESH_SUCCESS'
export const TOKEN_REFRESH_FAILURE = 'TOKEN_REFRESH_FAILURE'
export const TOKEN_REFRESH_RESET = 'TOKEN_REFRESH_RESET'

const storageProvider = StorageProviderFactory.create(STORAGE_TYPE_LOCAL)

export function tokenRefresh() {
  const refreshToken = storageProvider.getItem(API_JWT_REFRESH_TOKEN_NAME)
  return {
    [CALL_API]: {
      endpoint: '/api/token-refresh/',
      types: [TOKEN_REFRESH_REQUEST, TOKEN_REFRESH_SUCCESS, TOKEN_REFRESH_FAILURE],
      method: 'POST',
      tokenType: API_JWT_REFRESH_TOKEN_NAME,
      body: { refresh: refreshToken },
    },
  }
}
